import { IWorkflowsState } from 'source/app/presentation/MainPanel/Workflows/IWorkflowsState';
import { homeNode } from 'motw_core/Repositories/WorkflowRepository';

export const defaultState: IWorkflowsState = {
	rootNode: homeNode,
	visibleNodes: [],
	quizMode: true,
	sortMode: false,
	sortSource: homeNode,
	randomNode: homeNode,
	scrambledNode: homeNode,
	favoriteNodes: [],
	todayNodes: [],
	isMultiSelectMode: false,
	selectedNodeIds: [],
	isLoading: true
};
